import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import getMetaTagData from '../../../../src/common/services/getMetaTagData';

import Axios from "axios";
import cookieCutter from 'cookie-cutter';
import {
  couponCheck, couponDateFormat,
  couponNumberCheck,
  getCouponList,
  getLnbList, goLogin, isAndroid,
  isSbsApp, registerCoupon, setCouponNumber
} from "../../../../src/common/utils/passUtil";
import CouponBox from "../../../../src/component/m/pass/couponEnter/CouponBox";
import ServiceNotice from "../../../../src/component/m/pass/ServiceNotice";

function CouponEnter({ metaTagData, couponEnterData, isAndroid, isSbsApp, loginJwt, lang, code }) {

  //jwt 토큰 관리
  const [login_jwt, setLogin_jwt] = useState();
  const [platform, setPlatform] = useState();
  const [tabType, setTabType] = useState('hold');
  const [couponHoldList, setCouponHoldList] = useState(null);
  const [couponExpireList, setCouponExpireList] = useState(null);
  const [couponHoldCount, setCouponHoldCount] = useState('0');
  const [couponExpireCount, setCouponExpireCount] = useState('0');
  const [couponNumber1, setCouponNumber1] = useState('');
  const [couponNumber2, setCouponNumber2] = useState('');
  const [couponNumber3, setCouponNumber3] = useState('');
  const [registerAlertDisplay, setRegisterAlertDisplay] = useState('none');
  const [isSbsAppState, setIsSbsAppState] = useState(isSbsApp);

  const [paddingTop, setPaddingTop] = useState('0px');

  useEffect(() => {
    if (isSbsAppState) {
      setPaddingTop('50px');
    } else {
      setPaddingTop('0px');
    }
  }, [isSbsAppState]);


  //화면시작시 최초 한번 시작...
  useEffect(async () => {
    const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');

    setLogin_jwt(LOGIN_JWT);
    setPlatform(platformCookie);

    if (code) {
      const parts = code.split('-');
      if (parts.length === 3 && parts.every(part => part.length === 4)) {
        // 올바른 형식인 경우
        setCouponNumber1(parts[0]);
        setCouponNumber2(parts[1]);
        setCouponNumber3(parts[2]);
      } else {
        alert('쿠폰번호 형식이 잘못되었습니다. 올바른 형식으로 입력해주세요.');
      }
    }

    if (loginJwt) {
      await getCouponListData('hold');
      await getCouponListData('expire');
    }
  }, [code]);

  useEffect(async () => {
    //await getCouponListData(tabType);
  }, [tabType]);

  useEffect(() => {
    if (couponHoldList) {
      if (couponHoldList.retval == '0') {
        setCouponHoldCount(couponHoldList.cnt);
      }
    }

    if (couponExpireList) {
      if (couponExpireList.retval == '0') {
        setCouponExpireCount(couponExpireList.cnt);
      }
    }

  }, [couponHoldList, couponExpireList]);

  const getCouponListData = async (type) => {
    if (type == 'hold') {
      setCouponHoldList(await getCouponList(loginJwt, '1'));
    } else {
      setCouponExpireList(await getCouponList(loginJwt, '2'));
    }
  };

  const tabClickHandler = (type) => {
    if (type == tabType) return null;

    if (tabType == 'hold') {
      setTabType('expire');
    } else {
      setTabType('hold');
    }
  };

  const couponNumberClickEventHandler = () => {
    if (!loginJwt) {
      alert('로그인 후 쿠폰을 등록해주세요.');
      return false;
    }
  }

  const couponSubmitHandler = async () => {
    if (!loginJwt) {
      alert('로그인 후 쿠폰을 등록해 주세요.');
      window.location.href = goLogin();
    }

    let couponNumber = couponNumberCheck(couponNumber1) + '-' + couponNumberCheck(couponNumber2) + '-' + couponNumberCheck(couponNumber3);

    if (couponCheck(couponNumber)) {
      const registerResult = await registerCoupon(login_jwt, couponNumber);
      if (registerResult.retval == '0') {
        setRegisterAlertDisplay('block');

        setTimeout(() => {
          setRegisterAlertDisplay('none');
        }, 1000);

        window.location.replace('/m/pass/couponEnter');
        await getCouponListData('hold');
      } else {
        alert(registerResult.errmsg);
      }
    }
  };

  return (
    <>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_M_PASSMONEY_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
        <script src='//developers.kakao.com/sdk/js/kakao.min.js' />
        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents">
        <div className="passmoneyContents" style={{ paddingTop }}>
          {isSbsApp && getLnbList('app')}
          {lang == 'ko' ?
            (<div className="passmoneyCont_coupon">
              <div className="curationBannerWrap" style={{ backgroundColor: '#26AD8D' }}>
                {isSbsApp && (
                  <img src="/images/pass/m/couponBnr_app.png" className="curationBanner"
                    alt="SBS 쿠폰인증 센터 쿠폰 등록 후 사용하세요!" />)}
                {!isSbsApp && (
                  <img src="/images/pass/m/couponBnr.png" className="curationBanner"
                    alt="SBS 쿠폰인증 센터 쿠폰 등록 후 사용하세요!" />)}
              </div>
              <strong className="couponRegisterForm-title">쿠폰 코드를 입력해주세요.</strong>
              <div className="couponRegisterFormWrap">
                <fieldset>
                  <legend>쿠폰등록</legend>
                  <div className="couponRegisterForm">
                    <div className="couponRegisterTop_w">
                      <div className="couponRegisterTop_logo"><img src="/images/pass/m/sbsplay_logo.png" alt="SBS play" /></div>
                      <p className="couponRegisterTop_text">쿠폰번호 12자리 입력</p>
                    </div>
                    <div className="couponRegister_input_w">
                      <input type="text" className="couponRegister-input" placeholder="0000" value={couponNumber1} onChange={(e) => setCouponNumber1(couponNumberCheck(e.target.value))} />
                      <span className="couponRegister-dash"></span>
                      <input type="text" className="couponRegister-input" placeholder="0000" value={couponNumber2} onChange={(e) => setCouponNumber2(couponNumberCheck(e.target.value))} />
                      <span className="couponRegister-dash"></span>
                      <input type="text" className="couponRegister-input" placeholder="0000" value={couponNumber3} onChange={(e) => setCouponNumber3(couponNumberCheck(e.target.value))} />
                    </div>
                    <input type="submit" onClick={couponSubmitHandler} className="couponRegister-btn" value="쿠폰등록" />
                  </div>
                  <div className="couponRegisterAlert_w" style={{ display: registerAlertDisplay }}>
                    <div className="couponRegisterAlert">쿠폰이 발급되었습니다.</div>
                  </div>
                </fieldset>
              </div>
              <div className="tabListWrap_coupon">
                <a href="#none" className={`tabBtn ${tabType == 'hold' ? 'current' : ''}`}
                  onClick={() => tabClickHandler('hold')}>보유쿠폰 <strong className="text_number">{couponHoldCount}</strong></a>
                <a href="#none" className={`tabBtn ${tabType == 'expire' ? 'current' : ''}`}
                  onClick={() => tabClickHandler('expire')}>사용완료쿠폰 <strong className="text_number">{couponExpireCount}</strong></a>
              </div>
              {tabType == 'hold' && (
                <CouponBox data={couponHoldList} tabType={tabType} lang={lang}></CouponBox>)}
              {tabType == 'expire' && (
                <CouponBox data={couponExpireList} tabType={tabType} lang={lang}></CouponBox>)}
              {couponEnterData.service_notice && (<div className="noticeList_wrap"><ServiceNotice data={couponEnterData.service_notice}></ServiceNotice></div>)}
            </div>)
            : (
              <div className="passmoneyCont_coupon">
                <div className="curationBannerWrap" style={{ backgroundColor: '#26AD8D' }}>
                  <img
                    src="/images/pass/m/eng_couponBnr.png" className="curationBanner"
                    alt="SBS Coupon Registration Center" /></div>
                <strong className="couponRegisterForm-title">Enter Your Coupon Code.</strong>
                <div className="couponRegisterFormWrap">

                  <fieldset>
                    <legend>쿠폰등록</legend>
                    <div className="couponRegisterForm">
                      <div className="couponRegisterTop_w">
                        <div className="couponRegisterTop_logo"><img src="/images/pass/m/sbsplay_logo.png" alt="SBS play" /></div>
                        <p className="couponRegisterTop_text">쿠폰번호 12자리 입력</p>
                      </div>
                      <div className="couponRegister_input_w">
                        <input type="text" className="couponRegister-input" placeholder="0000" value={couponNumber1} onClick={couponNumberClickEventHandler} onChange={(e) => setCouponNumber1(couponNumberCheck(e.target.value))} />
                        <span className="couponRegister-dash"></span>
                        <input type="text" className="couponRegister-input" placeholder="0000" value={couponNumber2} onClick={couponNumberClickEventHandler} onChange={(e) => setCouponNumber2(couponNumberCheck(e.target.value))} />
                        <span className="couponRegister-dash"></span>
                        <input type="text" className="couponRegister-input" placeholder="0000" value={couponNumber3} onClick={couponNumberClickEventHandler} onChange={(e) => setCouponNumber3(couponNumberCheck(e.target.value))} />
                      </div>
                      <input type="submit" onClick={couponSubmitHandler} className="couponRegister-btn" value="쿠폰등록" />
                    </div>
                    <div className="couponRegisterAlert_w" style={{ display: registerAlertDisplay }}>
                      <div className="couponRegisterAlert">쿠폰이 발급되었습니다.</div>
                    </div>
                  </fieldset>
                </div>

                <div className="tabListWrap_coupon">
                  <a href="#none" className={`tabBtn ${tabType == 'hold' ? 'current' : ''}`}
                    onClick={() => tabClickHandler('hold')}>Available coupons <strong
                      className="text_number">{couponHoldCount}</strong></a>
                  <a href="#none" className={`tabBtn ${tabType == 'expire' ? 'current' : ''}`}
                    onClick={() => tabClickHandler('expire')}>Used coupons <strong
                      className="text_number">{couponExpireCount}</strong></a>
                </div>
                {tabType == 'hold' && couponHoldList && (
                  <CouponBox data={couponHoldList.List} tabType={tabType} lang={lang}></CouponBox>)}
                {tabType == 'expire' && couponExpireList && (
                  <CouponBox data={couponExpireList.List} tabType={tabType} lang={lang}></CouponBox>)}
                {couponEnterData.service_notice && (<div className="noticeList_wrap"><ServiceNotice data={couponEnterData.service_notice}></ServiceNotice></div>)}
              </div>
            )
          }
        </div>
      </div>
    </>
  );
}

const getCouponEnterData = async (lang) => {
  let result = null;

  //console.log('NEXT_PUBLIC_API_COUPON_ENTER_KO :>> ', process.env.NEXT_PUBLIC_API_COUPON_ENTER_KO);

  try {
    const apiUrl = lang == 'ko' ? process.env.NEXT_PUBLIC_API_COUPON_ENTER_KO : process.env.NEXT_PUBLIC_API_COUPON_ENTER_EN;
    const couponEnterData = await Axios.get(apiUrl, { timeout: 3000 });
    result = couponEnterData.data ? { ...couponEnterData.data } : null;

    //console.log(result);

  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { cookies } = ctx.req;
  const { LOGIN_JWT = null } = cookies;
  const { JOIN_PLATFORM } = cookies;
  const { pageSection, pageCategory, lang = 'ko', code = '' } = ctx.query;

  let metaTagData;
  let couponEnterData;
  let couponList;

  try {
    metaTagData = getMetaTagData((ctx.resolvedUrl || ctx.req.url || '').split('?')[0], 'couponEnter', pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
    couponEnterData = await getCouponEnterData(lang);
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      loginJwt: LOGIN_JWT,
      couponEnterData: couponEnterData,
      metaTagData,
      lang,
      code
    }
  };
}

export default CouponEnter;